const getCsrfToken = () => {
  const token_el = document.querySelector('meta[name="csrf-token"]');
  if (token_el) {
    return token_el.getAttribute('content');
  } else {
    return 'n/a';
  }
};

export const xhrConfig = () => ({
  headers: { 'X-CSRF-Token': getCsrfToken() },
});

const hiddenField = ({ name, value }) => {
  let field = document.createElement('input');
  field.type = 'hidden';
  field.value = value;
  field.name = name;
  return field;
};

const isPlainObject = (v) =>
  typeof v === 'object' && v !== null && !Array.isArray(v);

export const postForm = (action, fields) => {
  let form = document.createElement('form');
  form.method = 'POST';
  form.action = action;
  document.body.appendChild(form);
  for (const [name, value] of Object.entries({
    ...fields,
    ...{ authenticity_token: getCsrfToken() },
  })) {
    if (isPlainObject(value)) {
      Object.keys(value).forEach((key) => {
        const val = value[key];
        const keyName = `${name}[${key}]`;
        form.appendChild(hiddenField({ name: keyName, value: val }));
      });
    } else {
      form.appendChild(hiddenField({ name: name, value: value }));
    }
  }
  form.submit();
};
